import React from 'react';
import PropTypes from 'prop-types';
import { Paper, Table } from '@material-ui/core';
import DataTableHeader from './DataTableHeader/DataTableHeader';
import DataTableFooter from './DataTableFooter/DataTableFooter';
import DataTableBody from './DataTableBody/DataTableBody';
import './DataTable.css';

const DataTable = (props) => (
  <Paper style={{ width: '100%' }}>
    <div className="table-wrapper">
      <Table>
        <DataTableHeader
          columnHeaders={props.columns.map((column) => ({
            ...column.header,
            ...column.shared
          }))}
          direction={props.direction}
        />
        <DataTableBody
          data={props.bodyData}
          accessorFunctions={props.columns.map((column) => (value) => ({
            ...column.accessor(value),
            ...column.shared
          }))}
        />
        <DataTableFooter>{props.footerContent}</DataTableFooter>
      </Table>
    </div>
  </Paper>
);

DataTable.propTypes = {
  columns: PropTypes.array.isRequired,
  direction: PropTypes.string,
  bodyData: PropTypes.array.isRequired,
  footerContent: PropTypes.node
};

export default DataTable;
